module.exports = __webpack_public_path__ + "static/media/mobiles.84ced8d5.jpg";